<!-- {{shadowedListIndex}} -- {{shadowedList[shadowedListIndex]}} -->
<div class="custom-dropDown" [ngClass]="{'custom-dropDown-open': listHidden === false, 'disabled': isDisabled, 'app-error-border': (markRed && (control.touched || this.control.dirty)) }" aria-live="assertive">
  
  <select [formControl]="control" #selectElement>
    <ng-container *ngIf="asyncData">
      <option [value]="el?.mtext || el.name" *ngFor="let el of (aData | async)">{{el?.mtext || el.name}}</option>
    </ng-container>
    <ng-container *ngIf="!asyncData">
      <option [value]="el?.mtext" *ngFor="let el of valueArr">{{el?.mtext}} 2</option>
    </ng-container>
  </select>
  <img alt="Arrow Icon" aria-hidden="aria-hidden" src="assets/app-images/icons/icons-system-arrow-up-16@3x.png" class="icon" [ngClass]="{'icon-active': listHidden === false}" (click)="toggleItems()">
  <div class="select-selected" (click)="handleClick()" [ngClass]="{'select-arrow-active': listHidden === false}" tabindex="0" (focus)="myFocus($event)" (blur)="myBlur($event)" [attr.aria-label]="atrrAriaLabel" [attr.data-dropdown-id]="atrrDropDownId">{{val || 'COMMON.PHONE_NUM_PREFIX' | translate}}</div>
  <div class="select-items" [ngClass]="{'select-hide': listHidden === true}" style="max-height: 35vh; overflow-y: auto; z-index: 3;">
    <ng-container *ngIf="asyncData">
      <div *ngFor="let el of (aData | async)" (click)="onSelect(el.name)" [ngClass]="{'same-as-selected': (el?.name === val) || (el?.name === shadowedList[shadowedListIndex])}">{{el.name}}</div>
    </ng-container>
    <ng-container *ngIf="!asyncData">
      <div *ngFor="let el of valueArr" (click)="onSelect(el)" [ngClass]="{'same-as-selected': ($any(el) === val) || ($any(el) === shadowedList[shadowedListIndex])}">{{el}}</div>
    </ng-container>
  </div>
  
</div>


// WEBPACK FOOTER //
// ./src/app/dpListNew/dplistNew.component.html